var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.863a.968.968 0 0 0-1.936 0v6.454H4.609a.968.968 0 0 0 0 1.936h6.454v6.454a.968.968 0 0 0 1.936 0v-6.453h6.454a.968.968 0 1 0 0-1.936H13V3.863Z",
    fill: "#fff"
  })));
};
export default SvgPlus;